const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR: number = SECONDS_PER_MINUTE * 60;
const SECONDS_PER_DAY: number = SECONDS_PER_HOUR * 24;
const SECONDS_PER_WEEK: number = SECONDS_PER_DAY * 7;
const SECONDS_PER_MONTH: number = SECONDS_PER_DAY * 30;
const SECONDS_PER_YEAR: number = SECONDS_PER_DAY * 365;

const unitToThresholdInSecondsMap: { [key in Intl.RelativeTimeFormatUnit]?: number } = {
    second: SECONDS_PER_MINUTE,
    minute: SECONDS_PER_HOUR,
    hour: SECONDS_PER_DAY,
    day: SECONDS_PER_WEEK,
    week: SECONDS_PER_MONTH,
    month: SECONDS_PER_YEAR,
    year: Infinity,
};

function getTimestampDiffInSeconds(timestampA: number, timestampB: number): number {
    return timestampA / 1000 - timestampB / 1000;
}

function findBiggestPossibleUnit(value: number): Intl.RelativeTimeFormatUnit {
    return Object.keys(unitToThresholdInSecondsMap).find((unit) => {
        const thresholdInSeconds = unitToThresholdInSecondsMap[unit];
        return Math.abs(value) < Number(thresholdInSeconds);
    }) as Intl.RelativeTimeFormatUnit;
}

function getPreviousThreshold(unit: string): number | null {
    const units = Object.keys(unitToThresholdInSecondsMap);
    const thresholds = Object.values(unitToThresholdInSecondsMap);
    const foundThresholdIndex = units.indexOf(unit);

    return foundThresholdIndex === 0 ? null : Number(thresholds[foundThresholdIndex - 1]);
}

function transformTimestampDiffToUnit(timestampDiffInSeconds: number): number {
    const threshold = getPreviousThreshold(findBiggestPossibleUnit(timestampDiffInSeconds));

    if (threshold === null) {
        return Math.round(timestampDiffInSeconds);
    }

    return Math.round(timestampDiffInSeconds / threshold);
}

function castTimestampToReadableDiff(timestampA: number, timestampB: number = new Date().getTime()): string {
    const relativeTimeFormat = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
    const timestampDiffInSeconds = getTimestampDiffInSeconds(timestampA, timestampB);

    const unit = findBiggestPossibleUnit(timestampDiffInSeconds);
    const timestampDiffInUnit = transformTimestampDiffToUnit(timestampDiffInSeconds);

    return relativeTimeFormat.format(timestampDiffInUnit, unit);
}

export default castTimestampToReadableDiff;
